import { storeManager } from '@pressreader/appstore';

import { POPUPS_LEGACY_MODULE_NAME } from '../constants';
import { reducer } from './reducer';

storeManager.addFeature(POPUPS_LEGACY_MODULE_NAME, reducer);

export * from './actions';
export * from './selectors';
export * from './utils';
